<script>
  import { onMount } from "svelte";
  import { isExternalUrl } from "$lib/utilities/url-helpers";
  // eslint-disable-next-line  @ObamaFoundation/of-svelte/no-stores
  import { page } from "$app/stores";
  import ExternalLinkLabel from "../ExternalLinkLabel.svelte";

  export let title;
  export let description = "";
  export let url;

  export let bodyClass;
  export let titleClass;

  export let horizontal = false;
  export let id;

  const titleLineHeight = 26;
  const titleLineClampClass = horizontal ? "line-clamp-4 md:line-clamp-2" : "line-clamp-3";

  let titleRef;
  let descriptionClass = "";

  /**
   * truncate description based on title line count
   */
  function calculateDescriptionClass(titleHeight) {
    const titleLineCount = titleHeight / titleLineHeight;
    if (titleLineCount <= 3) {
      descriptionClass = horizontal ? "hidden md:line-clamp-3" : "line-clamp-3";
    } else {
      descriptionClass = "hidden";
    }
  }

  /** action */
  function initDescriptionClass(node) {
    // initial cal
    calculateDescriptionClass(node?.clientHeight);
  }

  onMount(() => {
    // eslint-disable-next-line no-constant-condition
    if (typeof ResizeObserver) {
      // recal on resize
      const resizeObserver = new ResizeObserver((entries) => {
        const entry = entries?.length && entries[0];
        calculateDescriptionClass(entry?.contentRect.height);
      });

      resizeObserver.observe(titleRef);

      return () => {
        resizeObserver.unobserve(titleRef);
      };
    }
  });

  $: isExternal = isExternalUrl(url, $page.url?.origin);
</script>

<!-- body -->
<div class={bodyClass}>
  <!-- title -->
  <a
    href={url}
    class="text-black no-underline focus:!bg-none focus:outline-none active:text-black text-size-20 {titleLineClampClass} {titleClass}"
    data-sveltekit-reload
    use:initDescriptionClass
    bind:this={titleRef}
    target={isExternal ? "_blank" : null}
    rel={isExternal ? "noopener noreferrer" : null}
    on:click={(e) => {
      e.stopPropagation();
    }}
    {id}
  >
    {#if isExternal}
      <ExternalLinkLabel text={title} textClass="" />
    {:else}
      {title}
    {/if}
  </a>

  <!-- description -->
  {#if description}
    <p class="font-normal {descriptionClass}">{description}</p>
  {/if}
</div>
